import { createAction, props } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import { IExtensionAgentListResponse } from "../../models/extension-agentlist.model";

export const loadExtensionAgents = createAction(
  "[Extensions] Load Agent List",
  props<{ orgId: string }>()
);
export const loadExtensionAgentsSuccess = createAction(
  "[Extensions] Load Agent List Success",
  props<{ response: IExtensionAgentListResponse }>()
);
export const loadExtensionAgentsFailure = createAction(
  "[Extensions] Load Agent List Failure",
  props<{ error: HttpErrorResponse }>()
);

export const deleteExtensionAgent = createAction(
  "[Extensions] Delete Agent",
  props<{ agentId: string; orgId: string }>()
);
export const deleteExtensionAgentSuccess = createAction(
  "[Extensions] Delete Agent Success",
  props<{ agentId: string; orgId: string }>()
);
export const deleteExtensionAgentFailure = createAction(
  "[Extensions] Delete Agent Failure",
  props<{ error: HttpErrorResponse }>()
);
